import React from 'react';
import '../../../../css/common/chat/ChatWorkspaceLayout.css';
import '../../../../css/common/chat/ChatSidePanel.css';

const joinClassNames = (...tokens) => tokens.filter(Boolean).join(' ');

const ChatWorkspaceLayout = ({
  className = '',
  children = null,
  targetSidebar = null,
  main = null,
  chatArea = null,
  sidePanel = null,
  mainClassName = 'chat-main-with-side',
}) => {
  const mainNode =
    main ||
    (chatArea || sidePanel ? (
      <div className={joinClassNames('chat-workspace-layout__main', mainClassName)}>
        {chatArea}
        {sidePanel}
      </div>
    ) : null);

  return (
    <div className={joinClassNames('chat-workspace-layout', className)}>
      {children || (
        <>
          {targetSidebar}
          {mainNode}
        </>
      )}
    </div>
  );
};

export default ChatWorkspaceLayout;
